import { LoadingState } from 'libs/callabo-state/types/LoadingState';
import { create } from 'zustand';
import { TeamDetail } from 'callabo-api/src';

export type TeamModel = TeamDetail;

type Store = {
  teamState: LoadingState<TeamModel[]>;
};

export const useTeamStore = create<Store>(() => ({
  teamState: { type: 'unloaded' },
}));

export const getTeamState = (): LoadingState<TeamModel[]> => {
  return useTeamStore.getState().teamState;
};
export const useTeamState = (): LoadingState<TeamModel[]> => {
  return useTeamStore((state) => state.teamState);
};
export const setTeamState = async (_teamState: LoadingState<TeamModel[]>): Promise<void> => {
  useTeamStore.setState({ teamState: _teamState });
};
